import React from 'react';

import './FormStyles.css';
import './Button.css';

const Button = (props) => {
    const { children, className } = props;

    let attributes = {
      ...props,

      className: 'form-button form-input-shadow' + (className ? ' ' + className : '')
    };

    return (
      <button {...attributes}>{children}</button>
    )
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/forms/Button.js